<header class="app-header navbar noselect">
  <div class="navbar-brand"></div>
</header>

<div class="login-container">
  <app-news />
  <div class="login-region d-flex justify-content-center align-items-center flex-column">
    <h1>
      <app-svg-icon type="tool" [inline]="true"/>
      {{ 'serviceUnavailable.title' | translate }}
    </h1>
    <p>
      @if(unavailableService() === 'Backend') {
        {{ 'serviceUnavailable.message' | translate }}
      } @else if (unavailableService() === 'CDC') {
        {{ 'serviceUnavailable.cdc_not_available' | translate }}
      }
    </p>

    @if(unavailableService() === 'Backend') {
      <a href=".">
        <button class="btn btn-primary btn-forward">{{ 'serviceUnavailable.retry' | translate }}</button>
      </a>
    }
  </div>
</div>
